import React from 'react';
import { css } from '@emotion/react';
import { AnimatePresence } from 'motion/react';
import { breakpoints } from '@frontend/responsiveness';
import { Button } from '@frontend/design-system';

interface DismissButtonProps {
  show: boolean;
  trackingId?: string;
  onDismiss?: () => void;
}

export const DismissButton: React.FC<DismissButtonProps> = ({ show, onDismiss, trackingId }) => {
  if (!show) {
    // Keep the dismiss slot reserved. This prevents misclicks where the user accidentally clicks the text link in the new banner when it appears without a dismiss button.
    return (
      <div aria-hidden='true' css={dismissButtonSpacerStyle} data-testid='global-banner-dismiss-btn-placeholder' />
    );
  }

  return (
    <AnimatePresence mode='popLayout'>
      <Button
        css={dismissButtonStyle}
        variant='secondary'
        iconName='x'
        onClick={onDismiss}
        aria-label='Dismiss'
        trackingId={trackingId}
        data-testid='global-banner-dismiss-btn'
      />
    </AnimatePresence>
  );
};

const dismissButtonSpacerStyle = css`
  width: 40px;
  min-width: 40px;
  height: 40px;
  visibility: hidden;
  pointer-events: none;
`;

const dismissButtonStyle = css`
  @container (max-width: ${breakpoints.small.min}px) {
    position: absolute;
    top: 0;
    right: 0;
  }
`;
